var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3576_98954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55 15.315c.133 0 .167-.017.283-.042l2.45-.491a1.63 1.63 0 0 0 .725-.392l5.942-5.942c.917-.916.917-2.483 0-3.391l-.508-.534c-.917-.916-2.492-.916-3.408 0L5.1 10.473a1.6 1.6 0 0 0-.392.725l-.525 2.475c-.066.467.067.917.392 1.242.258.258.642.392.967.392zm.467-3.858 5.933-5.959c.392-.391 1.117-.391 1.5 0l.517.517c.466.467.466 1.117 0 1.567L8.042 13.54l-2.525.425.491-2.508zM14.9 16.156H4.842c-.392 0-.659.259-.659.659s.325.658.659.658h10c.391 0 .725-.258.725-.658a.683.683 0 0 0-.667-.659"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3576_98954"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.167 3.832h11.467v13.633H4.167z"
  })))));
};
export default SvgEdit;